// extracted by mini-css-extract-plugin
export default {"wrapperPromocion":"futureTopupModal_wrapperPromocion__W3ne0","wrapperNow":"futureTopupModal_wrapperNow__uySdR"};